<template>
    <div
        class="px-5 py-0 space-y-3"
        role="radiogroup"
        aria-label="Target value"
    >
        <button
            v-for="value in values"
            :key="value.ulid"
            type="button"
            :disabled="readOnly"
            @click="handleClick(value)"
            :class="isSelected(value) ? selected : unselected"
            role="radio"
            :aria-checked="isSelected(value)"
            class="flex space-x-1 bg-transparent p-0 border-0"
        >
            <div>
                <zen-icon-box-checked
                    v-if="isSelected(value)"
                    aria-hidden="true"
                />
                <zen-icon-box-empty
                    v-if="!isSelected(value)"
                    aria-hidden="true"
                />
            </div>
            <div>
                <span v-if="value.display != ''">
                    {{ value.display }}
                </span>
                <span v-if="value.display == ''" class="italic"> (empty) </span>
            </div>
        </button>
    </div>
</template>

<script>
export default {
    name: 'NumberTargetToggle',
    computed: {
        selected() {
            return 'text-taupe-800'
        },
        unselected() {
            return (
                'text-taupe-500 ' +
                (this.readOnly
                    ? 'cursor-not-allowed'
                    : 'hover:text-sky-500 cursor-pointer')
            )
        },
    },
    methods: {
        isSelected(value) {
            return (
                this.currentValue != null &&
                this.currentValue.ulid == value.ulid
            )
        },
        handleClick(value) {
            if (!this.isSelected(value)) {
                this.toggle(value)
            }
        },
        toggle(value) {
            if (this.readOnly) {
                return
            }

            this.$emit('toggle', value)
        },
    },
    props: {
        readOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
        currentValue: {
            type: Object,
            required: true,
        },
        values: {
            type: Array,
            required: true,
        },
    },
}
</script>
